import React from "react";
import "./TabLink.css";

type listObj = {
  onClick?: () => void;
  active?: boolean;
  label?: string;
};

interface myComponentProps {
  list?: listObj[];
  onClick?: (param: any) => void;
  className?: string;
  type?: string;
  activeBg?: string;
  activeBgTwo?: string;
}

const TabLink = ({
  list,
  onClick,
  className,
  type,
  activeBg,
  activeBgTwo,
}: myComponentProps) => {
  return (
    <div
      className={`smart-send-tab-link-wrapper-index ${
        className ? className : ""
      } ${type === "two" ? "smart-send-tab-link-wrapper-index-two" : ""}`}
      style={
        {
          "--active-bg":
            activeBg || type === "two"
              ? activeBg || `#ffffff`
              : "rgba(248, 249, 255, 1)",
          "--active-bg-two": activeBgTwo || "rgba(92, 112, 175, 1)",
        } as React.CSSProperties
      }
    >
      {list?.length && (
        <>
          {list?.map((chi, idx) => {
            return (
              <div
                className={`row-item ${chi?.active ? `row-item-active` : ``}`}
                key={idx}
                onClick={() => {
                  if (!onClick) {
                    chi?.onClick && chi?.onClick();
                  } else {
                    onClick && onClick(chi);
                  }
                }}
              >
                <p className="text">{chi?.label || ""}</p>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default TabLink;
